module.exports = __webpack_public_path__ + "static/media/house_arryn.46b3e562.png";